import React from 'react';
import { Button, Modal } from 'react-bootstrap';

type ErrorFallbackProps = {
  error: Error;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  resetErrorBoundary: any;
};

export const errorHandler = (
  error: Error,
  info: { componentStack: string },
) => {
  // eslint-disable-next-line no-console
  console.log({ error, info });
  /* Disabled because app exceptions get tracked automatically to app insights
  appInsights.trackException({
    error,
    exception: error,
    severityLevel: SeverityLevel.Error,
    properties: { ...info },
  });
  */
};

function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  const [modalShow, setModalShow] = React.useState(true);

  const closeInfo = () => {
    setModalShow(false);
  };

  return (
    <Modal
      show={modalShow}
      onHide={closeInfo}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Sovelluksessa tapahtui virhetilanne!
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{error.message}</p>
        <pre>{error.stack.toString()}</pre>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={closeInfo}>Close</Button>
        <Button onClick={resetErrorBoundary} type="button">
          Yritä uudelleen
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorFallback;
